export default __webpack_public_path__ + "static/media/8-small.f56fca9c.png";